module.exports = __webpack_public_path__ + "h5/img/live-logo.262cb619.png";